import type { ReceiptTemplate } from '../schema';

export const littleCaesarsTemplate: ReceiptTemplate = {
  id: 'little-caesars',
  name: 'Little Caesars Receipt',
  brand: 'LITTLE CAESARS',
  description: 'Little Caesars pizza receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'lc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'LITTLE CAESARS',
        businessNameFontSize: 16,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lc-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 6:30 PM\nORDER #847291',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'lc-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'HOT-N-READY PEPPERONI', quantity: '1', price: '6.49', sku: '' },
          { id: '2', name: 'CRAZY BREAD 8PC', quantity: '1', price: '4.49', sku: '' },
          { id: '3', name: 'CRAZY SAUCE', quantity: '1', price: '0.89', sku: '' },
          { id: '4', name: '2-LITER PEPSI', quantity: '1', price: '2.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lc-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '14.86', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.23', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '16.09', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lc-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'CASH',
        fields: [
          { id: 'tend', label: 'CASH TEND:', value: '20.00' },
          { id: 'change', label: 'CHANGE:', value: '3.91' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'lc-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'PIZZA! PIZZA!\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

